import {AuthReducer} from './AuthReducer'
import {UserInfoReducer} from './UserInfo'

const {combineReducers} = require('redux')
const {Counter} = require('./counter')

export const allReducer = combineReducers({
  Auth: AuthReducer,
  Counter: Counter,
  UserInfo: UserInfoReducer
})

export type RootState = ReturnType<typeof allReducer>
